import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Optional: attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Global handling for AI credit exhaustion: any interactive AI call that
// returns 402 { error: "LIMIT_EXCEEDED", resource: "ai_credits", ... }
// broadcasts an event so a single app-level modal can prompt the user to
// upgrade, without every call site needing its own handling.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data
    if (error.response?.status === 402 && data?.error === 'LIMIT_EXCEEDED' && data?.resource === 'ai_credits') {
      window.dispatchEvent(new CustomEvent('ai-credits-exceeded', { detail: data }))
    }
    return Promise.reject(error)
  }
)

export default api
